import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useCalculateReturnOfInvestments } from '@/context/CalculatorReturnOfInvestment';
import { useCreateCalculationReturnOfInvestments } from '@/pages/CalculatorReturnOfInvestments/hooks';
import type { FormData } from '@/context/CalculatorReturnOfInvestment/types';
import * as S from '../../styles';

const { useFormInstance } = Form;

export function Footer() {
	const form = useFormInstance<FormData>();
	const { onNextStep, onUpdateId } = useCalculateReturnOfInvestments();
	const { isLoading, mutateAsync: createCalculation } = useCreateCalculationReturnOfInvestments();

	async function handleOnSubmit(): Promise<void> {
		const { personal } = await form.validateFields();
		const data = await createCalculation(personal);
		onUpdateId(data.id);
		onNextStep();
	}

	return (
		<Row justify="center">
			<Col>
				<S.NextButton loading={isLoading} onClick={handleOnSubmit}>
					{I18n.get('Next')}
				</S.NextButton>
			</Col>
		</Row>
	);
}
